
// src/components/layout/DashboardLayout.jsx
import { Outlet } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import Sidebar from './sidebar';
import Footer from './Footer';

const DashboardLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <AdminHeader />
      <div className="mt-10 flex flex-grow">
        {/* <Sidebar /> */}
        <main className="flex-grow p-6">
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default DashboardLayout;